import { useEffect, type ReactNode } from 'react';

interface SidePanelProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: string;
}

export default function SidePanel({
  open,
  onClose,
  children,
  width = 'max-w-[480px]',
}: SidePanelProps) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex">
      <div
        className="dc-fade-in absolute inset-0 bg-foreground-950/40"
        onClick={onClose}
        aria-hidden="true"
      ></div>
      <div
        className={`dc-slide-left relative z-10 flex h-full w-full ${width} flex-col bg-white`}
        role="dialog"
        aria-modal="true"
      >
        {children}
      </div>
    </div>
  );
}